import { MESSAGES } from './types';
import { getLauncherOrigin, getLobbyOrigin } from './allowed-origins';
import { closeEmbeddedLauncher } from '@/logic/web-wrapper/embedded-shell-actions';
import type { RootState } from '@/store/store';

type GameSessionTargets = {
    gameWindows: Window[];
    embeddedIframe: HTMLIFrameElement | null;
};

const sendToPopupWindows = (gameWindows: Window[], data: { type: string; payload?: unknown }): void => {
    const launcherOrigin = getLauncherOrigin();
    const lobbyOrigin = getLobbyOrigin();

    gameWindows.forEach((gameWindow) => {
        if (!gameWindow) {
            return;
        }
        gameWindow.postMessage(data, launcherOrigin);
        if (lobbyOrigin !== launcherOrigin) {
            gameWindow.postMessage(data, lobbyOrigin);
        }
    });
};

const sendToEmbeddedIframe = (iframe: HTMLIFrameElement | null, data: { type: string; payload?: unknown }): void => {
    if (!iframe?.contentWindow) {
        return;
    }
    iframe.contentWindow.postMessage(data, getLobbyOrigin());
};

export const sendMessageToGameSessions = (
    { gameWindows, embeddedIframe }: GameSessionTargets,
    data: { type: string; payload?: unknown }
): void => {
    sendToPopupWindows(gameWindows, data);
    sendToEmbeddedIframe(embeddedIframe, data);
};

export const sendRealityCheckMessageToGameSessions = (state: Pick<RootState, 'gameWindows' | 'embeddedGame'>): void => {
    sendMessageToGameSessions(
        {
            gameWindows: state.gameWindows ?? [],
            embeddedIframe: state.embeddedGame.iframeRef
        },
        { type: MESSAGES.CLOSE_REALITY_CHECK_MODAL }
    );
};

export const sendSessionUpdateToGameSessions = (
    state: Pick<RootState, 'gameWindows' | 'embeddedGame'>,
    jwt: string
): void => {
    if (!state.embeddedGame.isOpen && (state.gameWindows?.length ?? 0) === 0) {
        return;
    }

    sendMessageToGameSessions(
        {
            gameWindows: state.gameWindows ?? [],
            embeddedIframe: state.embeddedGame.iframeRef
        },
        { type: MESSAGES.SESSION_UPDATE, payload: { jwt } }
    );
};

export const sendShellCloseToEmbeddedGame = (): void => {
    closeEmbeddedLauncher();
};
